module.exports = __webpack_public_path__ + "static/media/ceuillettes.41330362.jpg";